import { type ReactNode } from "react";
import {
    AlignVerticalJustifyCenter,
    AlignVerticalJustifyEnd,
    AlignVerticalJustifyStart,
    type LucideIcon,
} from "lucide-react";

import { cn } from "@/lib/utils";
import { type TranslationKey } from "@/lib/localization";
import { ColumnVerticalAlign } from "@/lib/utils/lomdaV3/types";

export const COLUMN_ALIGNS: {
    value: ColumnVerticalAlign;
    icon: LucideIcon;
    labelKey: TranslationKey;
}[] = [
    {
        value: "top",
        icon: AlignVerticalJustifyStart,
        labelKey: "lomda-v3-editor.layout.align-top",
    },
    {
        value: "center",
        icon: AlignVerticalJustifyCenter,
        labelKey: "lomda-v3-editor.layout.align-center",
    },
    {
        value: "bottom",
        icon: AlignVerticalJustifyEnd,
        labelKey: "lomda-v3-editor.layout.align-bottom",
    },
];

const JUSTIFY: Record<ColumnVerticalAlign, string> = {
    top: "justify-start",
    center: "justify-center",
    bottom: "justify-end",
};

/** Fills the column's height so its blocks can sit at the top, middle or bottom. */
export function AlignedColumn({
    align = "top",
    children,
}: {
    align?: ColumnVerticalAlign;
    children: ReactNode;
}) {
    return (
        <div className={cn("flex h-full flex-col", JUSTIFY[align])}>
            {children}
        </div>
    );
}
